import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
 
import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import {variables} from './Variables.js';
import { FALSE } from 'sass';


 

 
  
 

export default function Tennis_Main_Ar() {
    const jsonbasket = variables.basename_url +'updates/index/Athlethixnet_HomeAr_Tennis.json';
 
    const [isLoading,setNisLoading] = useState(false);
    const navigate = useNavigate();
    const usenavigate=useNavigate();
 
    
    async function refda() {  
       
        //  To Show or Hidden Header And Footer
      document.getElementById('Arabic_Header').hidden = false;
      document.getElementById('Arabic_Footer').hidden = false;
      //
 


      setNisLoading(true);


      Get_Data_Tennis_Main_Ar()
  
    };
   
    useEffect(() => {
      
       
        setNisLoading(true);
   
        refda();
           },[] )

   

 
           
           const [JsonArray, setJsonArray] = React.useState([]);
           async function Get_Data_Tennis_Main_Ar(){
         
            JsonArray.splice(0);  //to clear All data in your page
        
           setNisLoading(true);
        
           axios.get(jsonbasket)  
        
                 .then(function (response) {
                 setNisLoading( false);
        
                   console.log(response.data);
               
                  
             
        
                 for (let i = 0; i <1 && i < response.data.length; i++) {
                 
                    JsonArray.push({
                
                    news_title: response.data[i].news_title,
                    news_date:response.data[i].news_date.split(" ")[0],
                     news_imagename:response.data[i].Image   ,
                    link:response.data[i].link,
                    Description:response.data[i].Description.replace("https://menafn.com/",variables.domain_name + "/") .replace("https://menafn.com",variables.domain_name  ) .replace("MENAFN",variables.domain) .replace("MENAFN",variables.domain)  ,
                    Category:response.data[i].Category,
                  
                  })
                  }
            })      
           }
             
 
         
             
 
     
            return (
          <>
 
 
 

 <div className="col-md-6 float-right">
                <div className="post-news-item-2">
                {JsonArray.map(Main=>     
  
  <div key= {Main.news_title}  >  
                  <div className="post-news-thumb">
                  
                    <a  href={ Main.link }>
                    <img   style={{ maxWidth: '360px', maxHeight: '190px' , minWidth: '360px', minHeight: '190px' }}  src={Main.news_imagename} alt="gallery" />
                    </a>
                  </div> 
                  <div className="post-news-content">
                    <h3 className="title1 "><a href={ Main.link } >{Main.news_title}</a></h3>
                    <a href={ Main.link }> <p className='JUUSTIFY A-Color' >{parse(Main.Description)}</p></a>
                    <div className="meta-post-2-style">
      
                      <div className="meta-post-categores">
                        <a href={ Main.link }className='colorForCategory'>{Main.Category}</a>
                      </div>
                      <div className="meta-post-date">
                        <span>{new Date(Main.news_date).toLocaleDateString('ar-EG')}</span>
                      </div>
                    </div>
                  </div>
                </div>
                 
)}
         </div>
              </div>
         </>
        );
    }


  
